import { SelectField } from '@flos/react-ui';
import type { DogClub_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import type { AttributeChangeProps } from '../../../types';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';
import { getOPCCoverableAttributeSelector } from '../../../../../recoil/selectors/getOPCCoverableAttributeSelector';
import { getDogClubOptionsSelector } from '../../../../../recoil/selectors/getDogClubOptionsSelector';

export const dogClubOptions: Array<{ label: string; value: DogClub_Top }> = [
    {
        label: 'Nej',
        value: 'NoDogClub'
    },
    {
        label: 'DKs civile hundeforening',
        value: 'DKsCivileHundeforening'
    },
    {
        label: 'Hjemmeværnet',
        value: 'Hjemmevaernet'
    },
    {
        label: 'Dansk Politihundeforening',
        value: 'DanskPolitihundeforening'
    },
    {
        label: 'Specialklubber under DKK',
        value: 'SpecialklubberUnderDKK'
    }
];

const DogClubChange = ({ updateCoverableAttribute }: AttributeChangeProps): React.JSX.Element => {
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const currentOPCAttribute = useRecoilValue(getOPCCoverableAttributeSelector)?.dog?.club;
    const dogClubDTOs = useRecoilValue(getDogClubOptionsSelector);
    const dogClubs = dogClubDTOs.map((dogClub) => {
        return {
            label: dogClub.displayName ?? '',
            value: dogClub.dogClub ?? ''
        };
    });
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const getHippoText = useHippoText();
    return (
        <>
            <h6>{getHippoText('DSS-PET-OPC-EDIT-DOG-CLUB-SELECT')}</h6>
            <SelectField
                iconShape="search"
                label={getHippoText('DSS-OPC-INPUT-LABEL')}
                options={dogClubs}
                onChange={(e) => {
                    const selectedIndex = e.target.selectedIndex;
                    const { value } = e.target.options[selectedIndex];
                    updateCoverableAttribute({ club: value as DogClub_Top });
                    setIsOpcDataFilled(true);
                }}
                defaultValue={currentOPCAttribute}
                disabled={isOpcFetching}
            ></SelectField>
        </>
    );
};

export default DogClubChange;
